import type { PointerEventModifiers } from '../../../types/pointer-events.js';
import type { InteractionMode } from '../types.js';

export const getActiveMode = (
  mode: InteractionMode,
  event: PointerEventModifiers,
  zoomDisabled: boolean = false,
) => {
  if ((event.metaKey || event.ctrlKey) && !zoomDisabled) {
    return 'zoom';
  } else if (event.altKey) {
    return 'pan';
  }

  return mode;
};
